import { render, staticRenderFns } from "./examPackPartner.vue?vue&type=template&id=ac58f0d0&scoped=true"
import script from "./examPackPartner.vue?vue&type=script&lang=js"
export * from "./examPackPartner.vue?vue&type=script&lang=js"
import style0 from "./examPackPartner.vue?vue&type=style&index=0&id=ac58f0d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac58f0d0",
  null
  
)

export default component.exports